import React from 'react';
import {WrapStyle, TextWrapStyle, IconWrapStyle} from "./styles";
import Typography from "shared/Typography";
import Icon from "shared/Icon";



const TypographyWithIcon = ({
                        children,
                        icon,
                        iconColor,
                        iconWidth,
                        iconHeight,
                        ...rest
                  }) => {


    return (
        <WrapStyle data-cy={'typography-with-icon'}>
            <IconWrapStyle>
                <Icon width={iconWidth} height={iconHeight}  name={icon} color={iconColor}/>
            </IconWrapStyle>
            <TextWrapStyle>
                <Typography {...rest}>
                    {children}
                </Typography>
            </TextWrapStyle>
        </WrapStyle>
    );
};

export default TypographyWithIcon;
